function handleHTMXError(e) {
  const { xhr } = e.detail
  let message

  switch (xhr.status) {
    case 0:
      message = "Unable to connect to Quimbee.<br/> " +
        "Please check your internet connection or try again " +
        "in a few minutes."
      break
    case 404:
      message = "Resource not found. Please refresh the page and try again."
      break
    case 422:
      message = "Your session has expired. Please refresh the page and " +
        "log in again. You should be able to continue " +
        "where you left off."
      break
    default:
      message = `Oops, something went wrong, we're sorry (status ${xhr.status}).<br/> ` +
        "Please try again in a few minutes or " +
        "<a href=\"https://help.quimbee.com/\">contact support</a> " +
        "if the problem persists."
  }

  showErrorMessage(message)
}

function showErrorMessage(message) {
  const errorContainer = document.querySelector("[data-htmx-response-error]")

  if (errorContainer) {
    errorContainer.innerHTML = message
    errorContainer.classList.remove("hidden")

    const hiddenParent = errorContainer.closest(".hidden")
    if (hiddenParent) {
      hiddenParent.classList.remove("hidden")
    }
    window.scrollTo(0, errorContainer.offsetTop)
  } else {
    message = message.replace(/(<([^>]+)>)/gi, "") // Strips out HTML
    alert(message)
  }
}

document.addEventListener("htmx:responseError", handleHTMXError)
document.addEventListener("htmx:sendError", handleHTMXError)
document.addEventListener("htmx:timeout", handleHTMXError)
document.addEventListener("htmx:sseError", handleHTMXError)
